import { render, staticRenderFns } from "./SettingsBorder.vue?vue&type=template&id=22cc11f2&"
import script from "./SettingsBorder.vue?vue&type=script&lang=js&"
export * from "./SettingsBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports